module.exports = __webpack_public_path__ + "img/icon_fault.50722b07.svg";